import { fieldLabels } from '../adminLabels'

/**
 * Veldfouten van "Opslaan" (422) leesbaar maken. De server stuurt paden zoals
 * `site.policy.shippingCost`, `site.openingHours.0.open` of `site.features.diary`; Sarah ziet
 * "Verzendkosten daaronder: moet een getal zijn" of "Openingstijden, dag 1 – Open: …".
 */

/** Groepen zonder eigen veldlabel: zo heten ze in Instellingen. */
const SECTION_LABELS: Record<string, string> = {
  openingHours: 'Openingstijden',
  features: 'Onderdelen',
  policy: 'Afspraken',
  salon: 'Salon',
  staff: 'Medewerkers',
  open: 'Open',
  close: 'Dicht',
  closed: 'Gesloten',
  diary: 'Fotodagboek',
}

/** "Verzendkosten daaronder (€)" → "Verzendkosten daaronder": de eenheid hoort bij het veld, niet bij de melding. */
const clean = (label: string) => label.replace(/\s*\([^)]*\)\s*$/, '')

// De groepsnamen hierboven winnen: dezelfde sleutel kan elders in het beheer een andere tekst hebben.
const labelOf = (key: string) => clean(SECTION_LABELS[key] ?? fieldLabels[key]?.label ?? key)

/** Eén pad als leesbare plek. Lijstnummers tellen vanaf 1. */
export function settingsFieldLabel(path: string): string {
  const parts = path.split('.').filter((p) => p !== 'site' && p !== '')
  const out: string[] = []
  parts.forEach((p, i) => {
    if (/^\d+$/.test(p)) {
      out[out.length - 1] = `${out[out.length - 1] ?? 'Regel'}, regel ${Number(p) + 1}`
      return
    }
    // Tussenliggende groepen (zoals `policy`) alleen noemen als ze geen eigen veldlabel volgen.
    const last = i === parts.length - 1
    if (!last && (p === 'policy' || p === 'salon') && parts.length > 1) return
    out.push(labelOf(p))
  })
  return out.join(' – ') || 'Instellingen'
}

/** Alle veldfouten als regels "Onderdeel: melding", in de volgorde van de server. */
export const settingsFieldMessages = (fields: Record<string, string>): string[] =>
  Object.entries(fields).map(([path, message]) => `${settingsFieldLabel(path)}: ${message.charAt(0).toLowerCase()}${message.slice(1)}`)
